
function loadingAnimation() {

    if ((desktopScreen.matches) && (getCookie('stop-loading') == null)) {
    
        gsap.registerPlugin(MorphSVGPlugin, SplitText);

        var master = gsap.timeline({
            delay:0,
            repeat:0,
            onComplete: endLoading
        }); 

        var morph = gsap.timeline({delay:0, repeat:1, yoyo:true, repeatDelay:0});
        
        const d_start = "M47.5,40.5c0.1,0,0.4,0,0.5,0V3.1c4.8,0,9.7,0,14.4,0v60.3C62.4,81,49.2,94,31.2,94S0,81,0,63.3c0-17.9,12.6-30.8,29.2-30.8C36.5,32.5,43.9,35.8,47.5,40.5z M14.6,63.4c0,9.7,7.1,16.8,16.8,16.8c9.4,0,16.4-7.2,16.4-16.8c0-9.7-7-16.8-16.4-16.8C21.7,46.5,14.6,53.6,14.6,63.4z";
        const d_end = "M41,49.3c0.9,0.6,2.9,0.1,1.6-1.2c-4.9-4.9-13.1-12-11.6-29.4c0.9-10.3,5-18,14.4-18c11,0,19.9,9.9,19.9,35.6c0,44.9-13.3,61.4-32.4,61.4C13.5,97.7,0,84.7,0,66.3c0-14.1,7.2-23.9,17.5-23.9C23.4,42.5,39,47.8,41,49.3z M9.4,49.8c1.1,1.1,2.9,0.7,4.2-0.5c1.8-1.7,2.1-2.7,1.5-3.3s-2.6-0.6-4.3,0.6C9.4,47.2,8.8,49.2,9.4,49.8z M31.8,65.3c2.3,3.2,5.4,4.5,7.5,2.7c1.5-1.8,1.2-6.4-0.6-9.4c-2-3.4-4.8-4.8-6.8-2.9C30.1,57.7,30.1,61.7,31.8,65.3z M35.6,12.2c0.1,2.3,3.4,1.6,4.4-0.9c0.7-1.8,3.3-3.9,2.2-6.6c-0.5-1.2-2.7-1.1-4.5,1.5C36.2,8.5,35.5,9.9,35.6,12.2z";
        const e1_start = "M70.3,63.4c0-18.1,13.1-30.7,31.2-30.7c17.4,0,29.2,12,29.2,28c0,2.4-0.2,4.9-0.7,7.6H87.5c-1.6,0-2.3,0.9-2.3,2.2c0,5.5,7,11,16.3,11c6,0,12.5-1.8,14.9-7h14.1c-4.3,13.6-15.9,19.3-29.6,19.3C83.1,93.9,70.3,81.3,70.3,63.4z M115,57.4c1.1,0,1.8-0.7,1.8-2c0-5.1-6-10.6-15.2-10.6c-8.9,0-15.4,4.8-16.9,12.6H115z";
        const e1_end = "M64,66.6c0-15,10-34.7,34.1-34.7c10.4,0,24.3,3.3,24.6,19.4c0.1,8.6-10.5,16-24.2,19.7c-6.4,1.5-7.8,2-10.2,2.4c-0.6,0.1-1.1,0.5-1.1,1c0,0.6,0.6,1,1.2,1c1.6-0.1,21.6-5.6,28-5.6c5.3,0,8.6,2.2,7.8,9.9c-1.3,10.6-16.9,19.8-32.8,19.8S64,86.7,64,66.6z M83.2,44.8c3.1-2,4.5-4.5,3.3-6c-1-1.2-4.4-1-7.5,1.1c-3.1,2-4.6,4.8-3.4,6C77,47.2,80.1,46.7,83.2,44.8z M87,69c1.7,0.5,3.4-1.1,4.2-5c0.9-3.9,0.4-6.7-1.6-7.2c-1.7-0.9-3.4,0.7-4,4.6C84.9,65.3,85.3,68.1,87,69z";
        const e2_start = "M138.1,63.4c0-18.1,13.1-30.7,31.2-30.7c17.4,0,29.2,12,29.2,28c0,2.4-0.2,4.9-0.7,7.6h-42.6c-1.6,0-2.3,0.9-2.3,2.2c0,5.5,7,11,16.3,11c6,0,12.5-1.8,14.9-7h14.1c-4.3,13.6-15.9,19.3-29.6,19.3C150.8,93.9,138.1,81.3,138.1,63.4z M182.7,57.4c1.1,0,1.8-0.7,1.8-2c0-5.1-6-10.6-15.2-10.6c-8.9,0-15.4,4.8-16.9,12.6H182.7z";
        const e2_end = "M124.8,66.6c0-15,10-34.7,34.1-34.7c10.4,0,24.3,3.3,24.6,19.4c0.1,8.6-10.5,16-24.2,19.7c-6.4,1.5-7.8,2-10.2,2.4c-0.6,0.1-1.1,0.5-1.1,1c0,0.6,0.6,1,1.2,1c1.6-0.1,21.6-5.6,28-5.6c5.3,0,8.6,2.2,7.8,9.9c-1.3,10.6-16.9,19.8-32.8,19.8S124.8,86.7,124.8,66.6z M144,44.8c3.1-2,4.5-4.5,3.3-6c-1-1.2-4.4-1-7.5,1.1c-3.1,2-4.6,4.8-3.4,6C137.7,47.2,140.9,46.7,144,44.8z M147.8,69c1.7,0.5,3.4-1.1,4.2-5c0.9-3.9,0.4-6.7-1.6-7.2c-1.7-0.9-3.4,0.7-4,4.6C145.7,65.3,146.1,68.1,147.8,69z";
        const p_start = "M206.4,61.8c0-17.6,13.1-30.6,31.1-30.6s31.2,13,31.2,30.7c0,17.9-12.6,30.8-29.2,30.8c-7.5,0-14.4-3.1-18.5-8.2h-0.2c0,10.8,0,21.6,0,32.5h-14.4V61.8z M237.4,78.6c9.7,0,16.8-7.1,16.8-16.8c0-9.7-7.1-16.8-16.8-16.8C228,45,221,52.2,221,61.8C221,71.6,228,78.6,237.4,78.6z";
        const p_end = "M186.2,73.4c0-23.6,11.5-40.5,32.7-40.7c19-0.1,34.7,11.5,34.7,30.3c0,10.4-6.7,21.8-17.7,22.1c-6.8,0.2-13.5-3.7-16-4.9c-1-0.7-1.5,0.9-0.6,1.5c12.5,9.8,17.2,16.5,17.2,27c0,5.6-7.7,10.6-18.8,10.6C196.2,119.4,186.2,97.9,186.2,73.4z M202,50c2.8-0.2,6-6,10.8-8.1c3.4-1.5,1.7-4.8-1-4.3c-5.5,1-9.2,4.4-11.3,6.7C198.4,47,198,50.4,202,50z M215.8,74.3c2,0,3.5-3.1,3.5-6.6c0-3.9-1.2-7-2.8-7c-2,0-3.3,2.6-3.4,6.4C212.6,71,214.1,74.3,215.8,74.3z";
        const a_start = "M274,65c0-23.1,20.4-34.7,42.7-34.6c17.9,0.1,24.7,17.1,24.7,40.7c0,7.7,0,11.4-1.8,16.3c-2,5.4-6.6,6.1-10.9,6.1c-12.1,0-15.2-2.9-11.4-16.3c0.2-0.9-1.2-1.2-1.6-0.2c-3.8,10-13.3,16.5-19.6,16.5C283.4,93.5,274,80.8,274,65z M289.6,47.4c3.4-3.4,7-6,11.6-7.7c1.1-0.5,0.7-2.8-1.3-2.8c-5.5-0.1-13.5,6-13.5,9.4C286.4,48.2,288.8,48.2,289.6,47.4z M311,73.1c1.8,0.5,4.2-2.2,4.5-6.2c0.6-3.5-0.2-6.4-2.2-6.7c-1.7-0.5-3.5,2.2-4.4,5.9C308.2,69.4,309.1,72.6,311,73.1z";
        const a_end = "M259.3,64.2c0-17.7,13.2-30.7,31.2-30.7s31.2,13,31.2,30.6v30.8c-4.8,0-9.7,0-14.4,0v-8.1c-0.1,0-0.1,0-0.2,0c-4,5.1-11,8.2-18.5,8.2C271.9,95.1,259.3,82.1,259.3,64.2z M290.6,81c9.4,0,16.4-7.1,16.4-16.8c0-9.5-7-16.8-16.4-16.8c-9.7,0-16.8,7.1-16.8,16.8C273.9,73.9,281,81,290.6,81z";
        const r_start = "M344.9,63.6c0-19.4,10.3-34.2,36.3-34.2c8.3,0,13.6,6.6,13.6,21.8c0,11.6-18.5,8.9-18.5,12.8c0,6.5,3.5,12,3.5,17.7c0,11.4-6.8,13.2-15.3,13.2C351.4,95,344.9,84.6,344.9,63.6z M361.2,41.6c1-0.7,2.6-2.2,3.3-2.6c2.3-1.1,1.6-4.5,0-3.9c-2,0.5-5.7,3.3-7.3,5c-2.4,2.6-2.3,6.5-0.2,6.6C358.4,46.9,359.2,43.8,361.2,41.6z";
        const r_end = "M331.2,64.1c0-17.6,13.2-30.6,31.2-30.6c0,4.6-0.1,9.3-0.1,13.9c-9.4,0-16.4,7.2-16.4,16.8c-0.1,10.3-0.1,20.4-0.2,30.7h-14.4L331.2,64.1L331.2,64.1z";
        const t_start = "M447.3,50l-23.9,2.4c-0.7,2-1.1,4-1.1,6.4c10-3.7,22.1-6.4,27.5-6.1c14.1,0.6,9.2,28-5.9,36.9c-5.9,3.5-12.5,5.5-18.8,5.6c-15.5,0.2-29-10.3-27.5-46.4l0.2-5.9c1.1-27.3,10.8-34,19.3-33.8c7.3,0.1,17.4,1.8,17.4,14.2c0,2.9-0.4,5.6-0.9,8H448C457.9,31.5,454.9,49.3,447.3,50z M409.1,27c1.6-7.2,5.1-8.1,5.1-11.7c0-1.3-2.4-2.4-5,0.4c-2.1,2.2-5.4,7.3-5.3,12.6C404.1,31,408.3,31,409.1,27z M442,37c3.5,0,7.6,0,7.6-1.7c0-1.5-1.6-1.8-7.3-1.5c-4.6,0.2-6.1,0.9-6.1,1.8C436.1,36.5,438.3,37,442,37z M449.6,60.1c1.7,0.6,3.3,0.2,3.9-0.9c0.5-1.1-0.5-2.7-2.2-3.2c-1.8-0.6-3.7-0.2-4,0.9C446.9,58,447.8,59.4,449.6,60.1z";
        const t_end = "M403.8,45.9h-17.7c0,6.1,0.1,12.2,0.1,18.3c0,9.5,7,16.8,16.4,16.8c0,4.6,0.1,9.3,0.1,13.9c-8.8,0-16.5-3.2-22.1-8.4c-5.6-5.5-9.1-13.2-9.1-22.1V18.9h7.5c2.3,0,4.6,0,7,0c0,5,0.1,9.9,0.1,14.9h17.7V45.9z";

        function morphLetter(selector, finalShape) {
            var tl     = gsap.timeline();
            var letter = document.querySelectorAll(selector);

            tl.to(letter, {
                duration: 1,
                morphSVG: finalShape,
                ease: "expo.inOut"
            });

            return tl;
        }

        function animateText() {
            var tl = gsap.timeline({
                onComplete: function () {
                }
            });

            var mySplitText = new SplitText("#intro-text", { type: "chars" });

            var stay = 3;

            tl.from(mySplitText.chars, {duration: 0.01, autoAlpha:0, delay: 0, ease: "power1.in", stagger: 0.03});
            tl.to(mySplitText.chars, {duration: 0.2, delay: 0, autoAlpha: 0, ease:"power1.out"}, "+=" + stay);

            return tl;
        }

        function moveAndFade() {

            var tl = gsap.timeline({
                onComplete: function () {
                }
            });
            
            var wrapper = document.querySelector('#loading-wrapper');
            var logo = document.querySelector('#loading-wrapper #intro');

            tl.to(logo, {
                duration: 0.7,
                top: '0',
                autoAlpha:0,
                ease: "power4.inOut"
            });

            tl.to(wrapper, {
                duration: 0.7,
                autoAlpha:0,
                ease: "power4.inOut"
            }, "<+=0");

            return tl;
        }


        morph.add( morphLetter('#d-start', d_end) );
        morph.add( morphLetter('#e1-start', e1_end), "-=0.9" );
        morph.add( morphLetter('#e2-start', e2_end), "-=0.91" );
        morph.add( morphLetter('#p-start', p_end), "-=0.93" );
        morph.add( morphLetter('#a-start', a_end), "-=0.96" );
        morph.add( morphLetter('#r-start', r_end), "-=0.98" );
        morph.add( morphLetter('#t-start', t_end), "-=0.99" );
        morph.add( morphLetter('#d-start', d_start), "-=0.2" );
        morph.add( morphLetter('#e1-start', e1_start), "-=0.9" );
        morph.add( morphLetter('#e2-start', e2_start), "-=0.91" );
        morph.add( morphLetter('#p-start', p_start), "-=0.93" );
        morph.add( morphLetter('#a-start', a_start), "-=0.96" );
        morph.add( morphLetter('#r-start', r_start), "-=0.98" );
        morph.add( morphLetter('#t-start', t_start), "-=0.99" );

        master.add( morph );
        master.add( animateText(), "-=4" );
        master.add( moveAndFade(), "-=1.5" );


        master.play();
    }
    else {
        endLoading();
    }

}

function endLoading() {
    document.querySelector('#loading-wrapper').remove();
    setCookie('stop-loading', 'true', 1);
}

